import { useState, useEffect, useRef } from "react";
// import { nanoid } from '@reduxjs/toolkit'
import MDAvatar from "dashboard/components/MDAvatar";
import MDAlert from "dashboard/components/MDAlert";


import { Icon, Grid } from "@mui/material";
import MDButton from "dashboard/components/MDButton";
// import useAlert from "hooks/useAlert";
import MDBox from "dashboard/components/MDBox";


function readFile(file) {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.addEventListener('load', () => resolve(reader.result), false)
    reader.readAsDataURL(file)
  })
}

const FileUploader = props => {
    // Create a reference to the hidden file input element
    const {profilImage, handleFile, imagesList, toggleModal, imgType, sx, error} = props; // handleUpload
    const ref = useRef();
    const [avatar, setAvatar]  = useState(profilImage);
    
    const handleChange = async event => {
      if (event.target.files && event.target.files.length > 0) {
        const imageDataUrl = await readFile(event.target.files[0])
        handleFile({imageUrl : imageDataUrl,name : event.target.files[0].name});
        /* eslint-disable */
        toggleModal(true)
      }
    };
    
    useEffect(()=>{
      setAvatar(profilImage)
    }, [profilImage]);
    
    useEffect(() => {
      if( imagesList["-1"] ) {
        const blob = imagesList["-1"]?.croppedImageUrl;
        blob?.url && setAvatar(blob?.url);   
      } 
    }, [imagesList])


    return (
      // write your building UI
      <div className="upload__image-wrapper">
        <MDButton  size="large" 
          sx={{
            borderRadius : imgType != "cover" ? "50%" : 0,
            width : imgType != "cover" ? sx?.width || "180px" : sx?.width || "100%",
            height: sx?.height || "180px",
            position : "relative",
            p:0
          }} 
          onClick={() => ref.current?.click()}
          ><MDAvatar variant={imgType != "cover" ? "circle" : "square"} src={avatar} shadow='lg' imgType={imgType} alt="Avatar" sx={{ height:"100%", width:"100%", border: ".2em solid white"}}  />
          <input
          ref={ref}
          type="file"
          accept="image/*"
          hidden
          onChange={handleChange}
        />
        <MDBox shadow='lg' sx={{position:"absolute",  transform: "translate(-12px, -12px)", 
              right :0, bottom :0, border: ".3em solid white", borderRadius :"50%",
              backgroundColor:"#97a1aa",
              padding:.5, height:40, width:40}}>
              <Icon size="large"  sx={{fontVariationSettings:{'FILL' : 1}, color: "white !important", fontSize:"1.4rem !important" }}>
                photo_camera
              </Icon>
        </MDBox>
        </MDButton>
        <Grid container>
          <Grid item xs={12} m={.5}>
          {error && imgType !== "cover" && <MDAlert color="error" sx={{p:1, minWidth:"100%"}}><small style={{ fontSize:"12px",whiteSpace: "normal" }}> {error.error || error.data.error} </small></MDAlert> }
          </Grid>
        </Grid>
      </div>
    );
}

export default FileUploader;